import { api } from './api-base';

// Notification management
export const notificationsApi = {
  // Get user's notifications
  get: async (): Promise<{ notifications: any[] }> => {
    const response = await api.get('/notifications', {
      headers: { 'Cache-Control': 'no-cache' },
      params: { t: Date.now() }
    });
    return response.data;
  },

  // Get unread count
  getUnreadCount: async (): Promise<{ count: number }> => {
    const response = await api.get('/notifications/unread-count', {
      headers: { 'Cache-Control': 'no-cache' },
      params: { t: Date.now() }
    });
    return response.data;
  },

  // Mark specific notification as read
  markAsRead: async (notificationId: string): Promise<{ success: boolean }> => {
    const response = await api.patch(`/notifications/${notificationId}/read`);
    return response.data;
  },

  // Mark all notifications as read
  markAllAsRead: async (): Promise<{ success: boolean }> => {
    const response = await api.patch('/notifications/read-all');
    return response.data;
  },
};
